import { InteractionRequiredAuthError, PublicClientApplication } from '@azure/msal-browser';
import { BehaviorSubject } from 'rxjs';
import { interpret } from 'xstate';
import { GlobalRxStores } from '../reactiveX/globalRxStores.js';
import { MSAL_CONFIG } from '../settings.js';
import { createAuthMachine } from './authMachine.js';
import { BlueUser } from './blueUser.js';
class MsalAuthService {
    /**
     *
     */
    constructor() {
        this.msalApplication = new PublicClientApplication(MSAL_CONFIG);
        this.authMachine = createAuthMachine();
        // this.msalApplication,
        // this.blueUserSubject
        // TODO utilize debug attach transition debugging messages or the like based on debug flags
        this.loginRequest = {
            scopes: [
                'api://c24871a8-25ee-4280-a557-3f858b0f2683/derp',
                'profile'
            ],
            prompt: 'select_account',
        };
        this.authInterpreter = interpret(this.authMachine).onTransition(state => 
        // eslint-disable-next-line no-console
        console.debug(`AuthMachine: State Transition Attempted. Changed to ${state.value}`));
        this.blueUserSubject = new BehaviorSubject(new BlueUser());
        GlobalRxStores.getDefaultStore().behaviorSubjectsByKey.set('blueUser', this.blueUserSubject);
    }
    // eslint-disable-next-line
    async start() {
        this.authInterpreter.start();
    }
    // eslint-disable-next-line
    async stop() {
        this.authInterpreter.stop();
    }
    getLocallyStoredMsalAccounts() {
        return this.msalApplication.getAllAccounts();
    }
    async attemptSilentTokenRetrieval(msalAccount) {
        const request = {
            scopes: this.loginRequest.scopes,
            account: msalAccount,
        };
        try {
            const response = await this.msalApplication.acquireTokenSilent(request);
            if (!response || !response.accessToken) {
                this.authInterpreter.send('MSAL_ACCESS_TOKEN_NOT_AVAILABLE');
            }
            else {
                this.authInterpreter.send({
                    type: 'MSAL_ACCESS_TOKEN_FOUND',
                    authenticationResult: response,
                });
            }
        }
        catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                this.msalApplication.loginRedirect(request);
            }
        }
    }
    /**
     *
     */
    async detectAndHandleRedirect() {
        try {
            const response = await this.msalApplication.handleRedirectPromise();
            if (response) {
                // eslint-disable-next-line no-console
                console.debug('handling redirect response');
                const msalAccount = response.account;
                if (!msalAccount) {
                    // WAT
                    this.authInterpreter.send('ERROR');
                    return;
                }
                this.authInterpreter.send({
                    type: 'SUCCESSFUL_MSAL_REDIRECT_WITH_TOKEN',
                    authenticationResult: response,
                });
                return;
            }
            if (!response) {
                // Likely a redirect wasnt requested during load
                // potentially locally available accounts
                const msalAccounts = this.getLocallyStoredMsalAccounts();
                if (!msalAccounts ||
                    !Array.isArray(msalAccounts) ||
                    !msalAccounts.length) {
                    this.authInterpreter.send('NO_MSAL_ACCOUNTS_FOUND');
                }
                else {
                    this.authInterpreter.send({
                        type: 'LOCAL_MSAL_ACCOUNTS_FOUND',
                        msalAccounts,
                    });
                }
            }
            // else {
            //   if (
            //     msalAccounts === null ||
            //     !Array.isArray(msalAccounts) ||
            //     !msalAccounts.length
            //   ) {
            //     // send({ type: 'ACCOUNTS_NOT_FOUND' });
            //     // Note authenticated
            //   } else if (msalAccounts.length === 1) {
            //     // send({ type: 'ACCOUNTS_FOUND', accounts });
            //   }
            //   else {
            //   }
            // }
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }
    async notifyUnauthenticated() {
        const blueUser = new BlueUser();
        blueUser.status = 'UNAUTHENTICATED';
        // TODO add methods that remove this burden
        if (!this.blueUserSubject) {
            throw new Error();
        }
        this.blueUserSubject.next(blueUser);
    }
    async notifyAuthenticated(accessToken) {
        const blueUser = new BlueUser();
        blueUser.status = 'AUTHENTICATED';
        blueUser.accessToken = accessToken;
        // TODO add methods that remove this burden
        if (!this.blueUserSubject) {
            throw new Error();
        }
        this.blueUserSubject.next(blueUser);
    }
    signInViaRedirect() {
        this.msalApplication.loginRedirect(this.loginRequest);
    }
}
export const AuthService = new MsalAuthService();
//# sourceMappingURL=authService.js.map